import React from 'react'
import PropTypes from 'prop-types'
import DownloadLink from './DownloadLink'

const linkSets = (coursenum, timeframe) => {
  const linkTypes = ['Topic', 'Section', 'Reading', 'Video']
  const linkHtml = []
  for (var i = 0; i < linkTypes.length; i++) {
    linkHtml.push(
      <div className="inline-block text-left mr-5" key={`${linkTypes[i]}`}>
        <ul className="iconset">
          <li>
            <DownloadLink
              coursenum={coursenum}
              linkType={linkTypes[i]}
              ext=".xlsx"
              timeframe={timeframe}
            />
          </li>
          <li>
            <DownloadLink
              coursenum={coursenum}
              linkType={linkTypes[i]}
              ext=".csv"
              timeframe={timeframe}
            />
          </li>
        </ul>
      </div>
    )
  }
  return linkHtml
}

const DownloadLinkSets = props => {
  return (
    <React.Fragment>
      {linkSets(props.coursenum, props.timeframe)}
    </React.Fragment>
  )
}

DownloadLinkSets.propTypes = {
  coursenum: PropTypes.string.isRequired,
  timeframe: PropTypes.string.isRequired,
}

export default DownloadLinkSets
